import { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import Resources from "../../shared-components/media-component/resources";
import Categories from "../../shared-components/media-component/categories";
import MediaGallery from "../../shared-components/media-component/mediaGallery";

const MediaPage = () => {
  const { id } = useParams();
  const location = useLocation();
  const [mediaId, setMediaId] = useState(null);
  const handleViewAllCategories = (mediaId) => {
    setMediaId(mediaId);
    setStep("Categories");
  };
  const [selectedMedia, setSelectedMedia] = useState(null);
  const handleViewGalleryMedia = (Id, mediaId, mediaType) => {
    setSelectedMedia({ id: Id, mediaId: mediaId, type: mediaType });
    setStep("MediaGallery");
  };
  const handleBackToCategories = (Id, mediaId, mediaType) => {
    setSelectedMedia({ id: Id, mediaId: mediaId, type: mediaType });
    setMediaId(Id);
    setStep("Categories");
  };
  useEffect(() => {
    setStep("Resources");
  }, [id, location.key]); // location.key - Triggers reset on same-route navigation

  const [step, setStep] = useState("Resources");
  return (
    <>
      {step === "Resources" && (
        <Resources
          onViewAll={handleViewAllCategories}
          onViewGalleryMedia={handleViewGalleryMedia}
        />
      )}
      {step === "Categories" && (
        <Categories Id={mediaId} onViewGalleryMedia={handleViewGalleryMedia} />
      )}
      {step === "MediaGallery" && (
        <MediaGallery media={selectedMedia} onBack={handleBackToCategories} />
      )}
    </>
  );
};

export default MediaPage;